<script>

	import Layout from '@/layouts/layoutB'
	import Masthead from '@/layouts/layoutB/masthead'
	import FooterCTA from '@/components/FooterCTA'
	import Scroller from '@/components/AnchorNav/Scroller'
	import ShareTools from '@/components/ShareTools'
	import $ from 'jquery'
	import { Text as TextBlock, Image as ImageBlock, Quote as QuoteBlock, Video as VideoBlock } from '@/components/BlogBlockTypes'

	const BLOCK_TYPES = {
		text: TextBlock,
		image: ImageBlock,
		quote: QuoteBlock,
		video: VideoBlock
	}

	export default {
		props: {
			entry: {},
			prehead: Function,
			byline: Function,
			shareTools: Boolean
		},
		metaInfo () {
			if(this.entry) {
				return this.$generateMetaInfo({
					title: this.entry.title,
					description: $(this.entry.intro).text(),
					image: this.entry.leadImage
				})
			} else {
				return {}
			}
		},
		methods: {
			scrollToTop (e) {
				e.preventDefault()
				Scroller.scrollToPosition(0)
			}
		},
		render () {
			if(!this.entry) {
				return null
			}
			return (
				<Layout>

					<template slot="masthead">
						<Masthead bgImage={this.entry.leadImage}>
							<template slot="headline">
								{this.prehead && this.prehead()}
								{this.entry.title}
								<div class="byline">
									{this.byline(this.entry)}
								</div>
							</template>
						</Masthead>
					</template>

					<template slot="body">
						<div class="content">

							{this.entry.body && this.entry.body.length ? (
								this.entry.body.map((block, idx) => {
									const Block = BLOCK_TYPES[block.type]
									return (
										<Block
											key={block.id}
											block={block}
											class="block"
											first={idx === 0}
										/>
									)
								})
							) : (
								<div domPropsInnerHtml={this.entry.bodyHtml} />
							)}

							{this.shareTools && (
								<TextBlock class="block">
									<div class="share">
										<strong class="share__headline">Share:</strong>
										<ShareTools />
									</div>
								</TextBlock>
							)}

							<a href="" class="top-anchor" title="Back to Top" onClick={this.scrollToTop}>
								<sprite name="arrow" class="top-anchor__arrow" />
							</a>
						</div>
					</template>

					<template slot="footer">
						<FooterCTA />
					</template>

				</Layout>
			)
		}
	}
</script>

<style lang="scss" scoped>

	@import "responsive-font";

	.content {
		width:100%; padding:0; color:#2f2f2f;
		blockquote {
			@include media(small, large) {
				margin-left:5vw; margin-right:5vw;
			}
		}
	}

	.block {
		&.text-block,
		& + .block {
			margin-top:4vw;
		}
	}

	.back {
		@include responsive-font(13);
		color: #6D6E71; position:relative; top: -6rem; left: 2rem;

		&__arrow {
			fill:#6D6E71; width:1.2rem; height:1.2rem; transform:rotate(90deg); vertical-align:middle;
		}
	}

	.top-anchor {
		position:relative; bottom:-16rem; left:50%; transform:translateX(-50%); cursor:pointer; padding:0; margin: 0;
		&__arrow {
			fill:#000; width:2.6rem; height:2.6rem; vertical-align:middle; transform:rotate(180deg)
		}
	}

	.byline {
		font-size:45%; margin-top:.7em; text-transform:none; 	font-family:"proxima-nova", sans-serif;
		@include media(small, large) {
			font-size:50%; margin-top:1em;
		}
	}

	.share {
		display:flex; align-items:center;
		&__headline {
			margin-left:auto; margin-right:1rem;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/ArticleEntry/index.vue